var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.415,
    height: 9.268,
    viewBox: "0 0 23.415 9.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#45338c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M163.182,1483.684a1.243,1.243,0,0,1-1.176,1.019,3.633,3.633,0,0,0-1.072.233c-.706.219-1.4.486-2.107.7-1.146.339-2.313.608-3.446.985-.586.2-1.091.726-1.676.811a9.354,9.354,0,0,0-2.6,1.213c-.435.2-.928.279-1.367.474-.652.29-1.273.648-1.92.95-.351.164-.736.254-1.087.417-.145.067-.223.267-.363.359a5.854,5.854,0,0,1-2.5,1,1.449,1.449,0,0,1-.73-.226,3.393,3.393,0,0,1-1.671-2.1c-.07-.2-.316-.34-.427-.538-.437-.781-.863-1.568-1.262-2.369-.051-.1.055-.3.124-.442a1.173,1.173,0,0,1,1.948-.509,8.682,8.682,0,0,1,1.1,1.082,1.872,1.872,0,0,1,.206.507,3.765,3.765,0,0,0,.42.874,1.358,1.358,0,0,0,1.531.06,16.128,16.128,0,0,1,3.747-1.713,6.2,6.2,0,0,0,.575-.283c.487-.213.984-.406,1.467-.627.655-.3,1.295-.635,1.953-.926a11.255,11.255,0,0,1,1.114-.387,26.535,26.535,0,0,1,4.259-1.193c1.019-.149,2.045-.245,3.068-.366.2-.024.411-.044.613-.081A.959.959,0,0,1,163.182,1483.684Z",
    transform: "translate(-139.768 -1482.575)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick4);
export default __webpack_public_path__ + "static/media/tick-4.037ca8d714368f288c8566f76469f7d3.svg";
export { ForwardRef as ReactComponent };